import {DOM} from "../../../../../plugins/levcharity/resources/scripts/helpers/DOM";

export  class Additional {

    constructor() {
        this.init();
        this.addEvents();
    }
    init() {
        this.#hideResigrationBtn();
        this.#hideMobileLogOutBtn();
        this.#makeHeaderSticky();
    }

    async addEvents(){
        const {gsap} = await import('gsap')
        DOM.addEvent('change', '[name="have_amount_raised"]', (event, option) => {
            if (option.value === 'no') {
                const paymentCommentsWrapper = DOM.el('.payment_comments_wrapper');

                if (paymentCommentsWrapper.style.height === 'auto'){
                    paymentCommentsWrapper?.classList.remove('animate')
                    gsap.to(paymentCommentsWrapper, {
                        height: 0,
                        duration: .2
                    });
                }
            } else if (['Other', 'other', 'i_have_webpage'].includes(DOM.el('#payment_method').value)) {
                const paymentCommentsWrapper = DOM.el('.payment_comments_wrapper');

                if (paymentCommentsWrapper.style.height === '0px') {

                    paymentCommentsWrapper?.classList.add('animate')
                    gsap.fromTo(paymentCommentsWrapper, {
                        height: 0,
                    }, {
                        height: 'auto',
                        duration: .2
                    });
                }
            }
        })

        DOM.addEvent('change', '#team_not_exists', (event) => {
            let isChecked = event.target.checked;
            let donate_link = DOM.el('#donate-link');
            let teamSelect = DOM.el('#team_name');
            console.log([donate_link, teamSelect]);
            if (!donate_link || !teamSelect) return;

            let defaultPermalink = '/?lc-add-to-cart=664';

            if (isChecked) {
                donate_link.href = defaultPermalink;
            } else {

                let selectedOption = teamSelect.options[teamSelect.selectedIndex];
                let selectedValue = selectedOption?.value || '';
                let permalink = selectedOption?.getAttribute('data-permalink');

                if (!selectedValue || !permalink) {
                    donate_link.href = defaultPermalink;
                } else {
                    donate_link.href = permalink;
                }
            }
        });

        DOM.addEvent('change', '#team_name', (event) => {
            const container = DOM.el('.payment_method .form-field.heading_only');
            if (!container) return;

            let payment_method = DOM.el('#payment_method');
            if (!payment_method) return;

            if (payment_method.value === 'cash_through' || payment_method.value === 'cash') {

                let selectedOption = event.target.options[event.target.selectedIndex];
                let permalink = selectedOption.getAttribute('data-permalink') || '/?lc-add-to-cart=664';

                const existingLink = DOM.el('#donate-link');
                if (existingLink) existingLink.remove();

                const link = document.createElement('a');
                link.href = permalink;
                link.textContent = wp.i18n.__('Donate', 'chaiathon');
                link.id = 'donate-link';
                link.target = '_blank';
                container.appendChild(link);
            }
        });



        DOM.addEvent('change', '#payment_method', (event) => {
            const container = event.target.closest('.form-field.heading_only');

            let team_name_select = DOM.el('#team_name');
            let selectedOption = team_name_select.options[team_name_select.selectedIndex];
            let permalink = selectedOption.getAttribute('data-permalink');

            if (!container) return;
            const section = container.closest('.form-group-wrapper');

            const existingLink = container.querySelector('#donate-link');
            const existingTextInformation = container.querySelector('#text-information');
            if (existingLink) {
                existingLink.remove();
            }
            if (existingTextInformation) {
                existingTextInformation.remove();
            }

            if (['cash_through', 'cash'].includes(event.target.value)) {
                const link = document.createElement('a');
                if (permalink){
                    link.href = permalink
                }else{
                    link.href = '/?lc-add-to-cart=664';
                }

                link.textContent = wp.i18n.__('Donate', 'chaiathon');
                link.id = 'donate-link';
                link.target = '_blank';
                container.appendChild(link);
            }

            DOM.el('.form-controls').style.display = ''

            if (['mail_to', 'submitted_to_camp', 'donation', 'mailed', 'i_have_webpage'].includes(event.target.value)) {
                const textInformation = document.createElement('p');
                textInformation.classList.add('levcharity_paragraph')
                let text = '';
                if (['mail_to'].includes(event.target.value)) {
                    text = 'Address: 5 Airport Road, Lakewood, NJ 08701';
                } else if (['submitted_to_camp'].includes(event.target.value)) {
                    text = 'If you have submitted your prize request through your school, please pick up your prize from your camp or school office.  If they do not have your prize, please contact us <a href="mailto:chaiathon@chailifeline.org">chaiathon@chailifeline.org</a>';
                    DOM.el('.form-controls').style.display = 'none'
                } else if (['donation'].includes(event.target.value)) {
                    text = 'Kindly provide the date and receipt confirmation number you received via email for your donation.';
                } else if (['mailed'].includes(event.target.value)) {
                    text = 'Approximate date you mailed in your Chai-A-Thon envelope';
                } else if (['i_have_webpage'].includes(event.target.value)) {
                    text = '<a href="/my-account/prizes/" class="levcharity_button primary_button large" style="margin-bottom: 4px">Claim Prize Here.</a>';
                }

                textInformation.innerHTML = text;
                textInformation.id = 'text-information';
                container.appendChild(textInformation);
            }

            const allSections = [...section.parentElement.children];
            const currentIndex = allSections.indexOf(section);
            allSections.forEach((section, index) => {
                if (index > currentIndex) {
                    section.style.display = ['submitted_to_camp', 'i_have_webpage'].includes(event.target.value) ? 'none' : ''
                }
            })



            if (['Other', 'other', 'donation', 'mailed'].includes(event.target.value)) {
                const paymentCommentsWrapper = DOM.el('.payment_comments_wrapper');

                if (paymentCommentsWrapper.style.height === '0px') {

                    paymentCommentsWrapper?.classList.add('animate')
                    gsap.fromTo(paymentCommentsWrapper, {
                        height: 0,
                    }, {
                        height: 'auto',
                        duration: .2
                    });
                }
            } else {
                const paymentCommentsWrapper = DOM.el('.payment_comments_wrapper');

                if (paymentCommentsWrapper.style.height === 'auto'){
                    paymentCommentsWrapper?.classList.remove('animate')
                    gsap.to(paymentCommentsWrapper, {
                        height: 0,
                        duration: .2
                    });
                }
            }
        });
    }

    #hideResigrationBtn(){
      let login =   DOM.el('body.logged-in');

        if (login && DOM.el('.home_page_registration_button')){
            DOM.el('.home_page_registration_button').style.display ='none'
        }
    }

    #hideMobileLogOutBtn(){
        let login = DOM.el('body.logged-in');
        let logOut = DOM.el('.woocommerce-MyAccount-navigation .woocommerce-MyAccount-navigation-link--logout')
        if (!login && logOut){
            logOut.style.display = 'none';
        }
    }

    #makeHeaderSticky () {
        const header = DOM.el('header');
        let headerHeight;
        if (header){
             headerHeight = header.offsetHeight;
        }


        const updateHeaderStyles = () => {
            if (header && headerHeight){
                headerHeight = header.offsetHeight;

                header.style.position = 'fixed';

                document.body.style.marginTop = `${headerHeight}px`
                document.body.style.setProperty('--header-height', `${headerHeight}px`)
            }

        };

        updateHeaderStyles();

        DOM.addEvent('scroll,resize,orientationchange', window, updateHeaderStyles)
    }

    #offlineDonateLink(){

    }
}   